module.exports = __webpack_public_path__ + "img/saverio-pizza.c33c9030.png";